import React, { useState } from "react";
import {Link} from "react-router-dom";
import * as Dapp from "@elrondnetwork/dapp";
import { getIssuedCollections, getCollectionsWithCreateRole } from "../../helpers/asyncRequests";
import { getAssignCreatorRoleTransaction } from "../../helpers/transactions";
//import WalletNFTGallery from "./WalletGallery";
//import TransferNFTModal from "./TransferNFTModal";
import { useHistory } from 'react-router-dom';
import WalletHeader from "../WalletInventory/WalletHeader";


//
import { db } from "../../Firebase.js";
import { getFirestore, collection, addDoc, setDoc, doc } from 'firebase/firestore';
//

const initData = {
    pre_heading: "Explore",
    heading: "Exclusive Digital Assets",
    content: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Laborum obcaecati dignissimos quae quo ad iste ipsum officiis deleniti asperiores sit.",
    btnText: "Load More"
}

//const data = require('../../db/giveaways.json')

const MyCollections = () => {
    const history = useHistory();
    const { loggedIn, address } = Dapp.useContext();
    const [inputAddress, setInputAddress] = useState();
    const [componentDidMount, setComponentDidMount] = useState(false);
    const [walletCollections, setwalletCollections] = useState([]);
    const [shouldShowList, setShouldShowList] = useState(false);
    const send = Dapp.useSendTransaction();
    
    const loadCollections = (address) => {
        let walletCollections = getIssuedCollections({address}).then(({ data }) => {
            if( data != undefined ){
                //console.log(data)
                return data
            }
                
        });
        return walletCollections;
    }
    
    const loadCollectionsWithCreateRole = (address) => {
        let resp = getCollectionsWithCreateRole({address}).then(({ data }) => {
            if( data != undefined ){
                // console.log(data)
                return data
            }
                
        });
        return resp;
    }
    
    const assignRole = (tokenIdentifier) => {
        
        //console.log( tokenIdentifier )
        //console.log( address )
        let transaction = getAssignCreatorRoleTransaction(tokenIdentifier, address);
        //console.log( transaction )
        send({ transaction: transaction, callbackRoute: "/transaction" });
    }
    
    React.useEffect(() => {
        if (componentDidMount)
            return;
        if (loggedIn) {
            
            let user = {
                wallet: "MAIAR",
                address: address,
                datetime: Math.round(+new Date()/1000)
            }
            setDoc(doc(db, "users", address), user, { merge: true } )
            
            loadCollections(address).then((val) => {
                        
                //console.log(val)
                setwalletCollections(val);
                setShouldShowList(true);
                
            });
            
        }
        else{
            history.push('/wallet-connect')
        }
        setComponentDidMount(true);
    }, []);
    
    return <section className="explore-area ">
                <div className="container">
                    
                    <WalletHeader />
                    
                    <div className="row justify-content-center">
                        <div className="col-12 col-md-6 ">
                            {/* Intro */}
                            <div className="intro text-left">
                                <h3 className="mt-3 mb-0">My collections</h3>
                            </div>
                        </div>
                        <div className="col-12 col-md-6 ">
                            {/* Intro */}
                            <div className="intro text-right">
                                <Link to="/create-collection" className="btn ml-lg-auto btn-bordered-white mt-3"  > <i className="icon-plus mr-2" /> Create collection </Link>
                            </div>
                        </div>
                    </div>
                    
                    { !shouldShowList &&
                        <div className="media-preloader pt-5" > <div className="loader"></div> </div>
                    }
    
                    {walletCollections?.length == 0 &&
                        <div className="row">
                            <div className="col-12 text-center">
                                <h3 className="mt-5 mb-0">Wallet does not have any collections. Create one now</h3>
                            </div>
                        </div>
                    }
                    
                    {walletCollections?.length > 0 &&
                        
                        <div className="row">
                            <div className="col-12">
                                
                            </div>
                            <div className="col-12">
                                
                                    {walletCollections.map((item, idx) => {
                                        return (
                                            <div className="row card-bg p-4" key={`exf_${idx}`}>

                                                <div  className="col-12 col-md-4 ">
                                                    <h4 className="m-0 card-bg">{item.name}</h4>
                                                    <h3 className="mt-3 mb-0 card-bg">{item.ticker}</h3>
                                                </div>

                                                <div  className="col-12 col-md-2 ">
                                                    
                                                </div>

                                                <div  className="col-12 col-md-6 text-right">
                                                    
                                                    { item.canCreate == false &&
                                                        <a  className="btn ml-lg-auto btn-bordered-white mt-3 mr-2" onClick={() => assignRole(item.ticker)}  > Assign Role </a>
                                                    }

                                                    { item.canCreate == true &&
                                                        <Link to={`/create-item?collectionTicker=${item.ticker}`} className="btn ml-lg-auto btn-bordered-white mt-3 mr-2"  > Create Item </Link>
                                                    }

                                                    <Link to={`/collection-items?collectionTicker=${item.ticker}&collectionName=${item.name}`} className="btn ml-lg-auto btn-bordered-white mt-3 "  > See Items </Link>

                                                </div>
                                                
                                            </div>
                                        );
                                    })}
                        
                            </div>
                        </div>
                    }
    
                                

                </div>
            </section>
                        
}

export default MyCollections;